// Componente reutilizable de overlay de carga con logo de Duetto
import React from 'react';

const LoadingOverlay = ({ isLoading, message = 'Cargando...', subMessage = 'Por favor, espere' }) => {
  if (!isLoading) return null;
  
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center" style={{ zIndex: 99999 }}>
      <div className="bg-white rounded-2xl p-8 shadow-2xl flex flex-col items-center">
        <div className="relative w-16 h-16 mb-4">
          <img 
            src="/duetto-isotipo.png" 
            alt="Cargando..." 
            className="w-full h-full object-contain animate-spin"
            style={{ animationDuration: '1.5s' }}
          />
        </div>
        <p className="text-lg font-semibold text-gray-700">{message}</p>
        {subMessage && <p className="text-sm text-gray-500 mt-1">{subMessage}</p>}
      </div>
    </div>
  );
};

export default LoadingOverlay;
